import React from 'react'
import { useLocation } from 'react-router-dom'

interface SecureEHRRouteProps {
  children: React.ReactNode
}

function isEHRAuthenticated(state?: string): boolean {
  return Boolean(state && state !== '')
}

/**
 * SecureRoute component that protects routes requiring authentication
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render when authenticated
 * @returns {JSX.Element} Protected route component
 */
const SecureEHRRoute: React.FC<SecureEHRRouteProps> = ({ children }) => {
  const location = useLocation()

  if (!isEHRAuthenticated(location.state)) {
    throw new Error('Access denied')
  }

  return <>{children}</>
}

export default SecureEHRRoute
